import { createAction, props } from "@ngrx/store";

export const MapaWidokActions = {
  uruchomMapaWidok: createAction('[MAPA_WIDOK] uruchomMapaWidok', props<{ widokMapyId: string }>()),
  zamknijMapaWidok: createAction('[MAPA_WIDOK] zamknijMapaWidok', props<{ widokMapyId: string }>()),
  aktualizujDane: createAction('[MAPA_WIDOK] aktualizujDane', props<{ widokMapyId: string, dane: any }>()),
  zapiszGrupePaskaCzasu: createAction('[MAPA_WIDOK] zapiszGrupePaskaCzasu', props<{ widokMapyId: string, daneInicjujacePasekCzasu: any }>()),
  ustawAktywneNarzedzie: createAction('[MAPA_WIDOK] ustawAktywneNarzedzie', props<{ narzedzieId: string }>()),
  wyczyscAktywneNarzedzie: createAction('[MAPA_WIDOK] wyczyscAktywneNarzedzie'),
  reset: createAction('[MAPA_WIDOK] reset')
}
